import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import Swal from 'sweetalert2';
import POPIEdit from './PumpSpareInternational/Edit';
import POAMEdit from './AraiManufacturing/Edit';

function PoEdit() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [potype, setpotype] = useState('');
  const [pocategory, setpocategory] = useState('');
  const [poData, setPoData] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}purchaseOrder/findById/${id}`, {
          headers: authHeader(),
        });
        setPoData(response.data);
        setpotype(response.data.potype);
        setpocategory(response.data.pocategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (potype === 'Pump Spare' && pocategory === 'International') {
      return <POPIEdit />;
    } else if (potype === 'Manufacturing') {
      return <POAMEdit />;
    }
    return null;
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${BASE_URL}purchaseOrder/poCancelStatus/${id}`, {
          headers: authHeader(),
        });
        if (response.data.length === 0) {
          Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
        } else {
          navigate(`/poindex/${pointindex}`);
          Swal.fire('Deleted!', 'Deleted successfully.', 'success');
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };

  async function cancelHandler() {
    try {
      await axios.get(`${BASE_URL}purchaseOrder/poCancelStatus/${id}`, {
        headers: authHeader(),
      });
      navigate(`/poindex/${pointindex}`);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>UPDATE PURCHASE ORDER</h6>
          <div className="view-buttons">
            {pocategory === "Domestic" && potype === "Manufacturing" && poData?.status !== "Converted" && (
              <Link to={`/potomrnconvert/${id}`}>
                <button className="button-70">Convert To MRN</button>
              </Link>
            )}
            <Link to={`/poindex/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select disabled value={potype} onChange={(e) => setpotype(e.target.value)}>
                  <option value="">--Please choose an option--</option>
                  {/* Removed Tubing */}
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a PO Category:</Form.Label>
                <Form.Select disabled value={pocategory} onChange={(e) => setpocategory(e.target.value)}>
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {renderPageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default PoEdit;
